<template>
  <div :class="['bread-crumb', splitLine && 'line']">
    当前位置：
    <div
      class="route"
      @click="goHome"
    >
      首页
    </div>
    <i class="el-icon-arrow-right" />
    <div
      :class="crumb.catalogId && 'route'"
      @click="goRootNav"
    >
      {{ rootNode.name }}
    </div>
    <template v-if="crumb.catalogId && currentNode.catalogId != rootNode.catalogId">
      <i
        class="el-icon-arrow-right"
      />
      <div
        class="route"
        @click="gotoCurrentNode"
      >
        {{ currentNode.name }}
      </div>
    </template>
  </div>
</template>

<script>
import { findRootNode } from '../../../../../lib/utils';

export default {
    name: 'Breadcrumb',
    props: {
        splitLine: {
            type: Boolean,
            default: false,
        },
        crumb: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    computed: {
        flatTreeList () {
            return this.$store.getters['system/getFlatTreeList'];
        },
        rootNode () {
            return findRootNode(this.flatTreeList, this.$route.query.catalogId);
        },
        currentNode () {
            return this.flatTreeList.find(itm => +itm.catalogId === +this.crumb.catalogId);
        },
    },
    methods: {
        goHome () {
            this.$router.push({
                path: '/webModulePage/home',
                query: { siteId: this.$route.query.siteId },
            });
        },
        goRootNav () {
            if (this.crumb.catalogId) {
                const query = this.$route.query;
                delete query.currCatalogId;
                delete query.contentId;
                const node = this.flatTreeList.find(itm => +itm.pCatalogId === +this.rootNode.catalogId);
                if (node) query.catalogId = node.catalogId;
                this.$router.push({
                    path: '/webModulePage/articleList',
                    query,
                });
            }
        },
        gotoCurrentNode () {
            let query = this.$route.query;
            const catalogId = query.currCatalogId;
            delete query.contentId;
            delete query.currCatalogId;
            this.$router.push({
                path: '/webModulePage/articleList',
                query: Object.assign({}, query, { catalogId }),
            });
        },
    },
};
</script>

<style scoped lang="scss">
.bread-crumb {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    padding-bottom: 10px;
    color: #657180;
    &.line {
        border-bottom: 1px solid #D8D8D8;
    }
    div {
        margin: 0 4px;
    }
    .route {
        cursor: pointer;
        transition: color 0.3s;
        &:hover {
            color: #2873E9;
        }
    }
}
</style>
